import store from 'utilities/store';
import Keys from 'stateKeys';
import isStringSet from 'utilities/is/isStringSet';

export default function headers(others = {}) {

    const allHeaders = {
        ...others,
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    const token = store.get(Keys.Auth.TokenKey);

    if (isStringSet(token)) {
        allHeaders['X-Session-Token'] = token;
    }

    return allHeaders;
}
